import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import moment from "moment";
import nophoto from "../../../Images/noImage.jpg"

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function JobApplications() {
    const [allData, setAllData] = useState([]);


    const fetchAllData = async () => {
        try {
            const response = await HomeService.getJobApplications();
            console.log("WEJ23", response);
            const formattedData = response?.data
                .filter((item) => item.Property !== null)
                .map((item, index) => ({
                    ...item,
                    sln: index + 1,
                }));


            setAllData(formattedData || []);
        } catch (error) {
            console.error("Error fetching allData:", error);
            toast.error("Failed to fetch allData.");
        }
    };

    const toggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === true ? false : true;
            await HomeService.updateUserStatus(id, { status: newStatus });
            fetchAllData();

            // toast.success(`Property status updated to ${newStatus}!`);
        } catch (error) {
            toast.error("Failed to update property status.");
            console.error("Error updating status:", error);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, []);

    // Define columns for the data table
    const columns = [
        { name: "SL#", selector: (row) => row.sln, sortable: true },
        { name: "Date", selector: (row) => moment(row?.createdOn).format("DD-MM-YYYY"), sortable: true },
        { name: "Job Title", selector: (row) => row?.jobPost?.jobTitle || "N/A" },
        { name: "Job Category", selector: (row) => row?.jobCategory?.catName || row?.jobPost?.category?.catName || "N/A" },
        { name: "Applicant Name", selector: (row) => row?.name },
        { name: "Applicant Email", selector: (row) => row?.email },
        { name: "Applicant Phone", selector: (row) => row?.phone },
        {
            name: "Resume",
            cell: (row) => (
                <>
                    {row?.cvFile &&
                        <a href={row?.cvFile} target="_blank">
                            {row?.cvFile?.split('.').pop().toLowerCase() === "docx" || row?.cvFile?.split('.').pop().toLowerCase() === "doc" ? <><i class="fas fa-2x fa-file-word"></i></> : row?.cvFile?.split('.').pop().toLowerCase() === "pdf" ? <><i class="fas fa-2x fa-file-pdf"></i></> : "NO file uploaded"}
                        </a>
                    }
                </>
            ),
        },
    ];

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid" id="edit-section">
                <div className="mt-5">
                    <h2 className="text-center" style={headLineStyle}>Job Applications</h2>
                    <hr />




                    <DataTable columns={columns} data={allData} pagination />
                </div>
            </div>
        </div>
    );
}

export default JobApplications;
